import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../pages/assessment';
import { selectMedicalInfoAnswers } from '../../../redux/assessment';
import { hasOtherPlan } from '../../../redux/helpers/assessment';
import OONProviderTermination from './oon-provider-termination';
import OtherInsurancePlan from './other-insurance-plan';
import TerminateWithOptionToChange from './terminate-with-option-to-change';

const NotInNetwork = () => {
  const dispatch = useAppDispatch();

  const medicalInfoAnswers = useSelector(selectMedicalInfoAnswers);
  const { MI_InsuranceProvider, MI_InsurancePlan } = medicalInfoAnswers;
  const hasOtherInsurancePlan = hasOtherPlan(MI_InsurancePlan);

  const showTerminateWithOptionToChange =
    MI_InsuranceProvider.includes('Other');
  const showOONProviderTermination = !MI_InsurancePlan?.length;

  if (showTerminateWithOptionToChange) return <TerminateWithOptionToChange />;
  if (showOONProviderTermination) return <OONProviderTermination />;
  if (hasOtherInsurancePlan) return <OtherInsurancePlan dispatch={dispatch} />;

  return <OONProviderTermination />;
};

export default NotInNetwork;
